/**
 * custom-gallery-dots.js
 * ======================
 * Mitwanderndes Fenster für die Navigationspunkte der Produktgalerie (mobil).
 *
 * Es sind höchstens vier Punkte gleichzeitig zu sehen. Der aktive ist zu einer
 * Pille gestreckt, die Randpunkte schrumpfen, solange dahinter noch weitere
 * liegen – das ist der Hinweis, dass es in diese Richtung weitergeht.
 *
 *   offset = clamp(current - 2, 0, total - 4)
 *
 * Dadurch bleibt die Pille ab dem dritten Bild in der vorletzten Position
 * stehen und rückt erst ganz nach rechts, wenn das letzte Bild erreicht ist.
 * Es gibt also immer die Auskunft "es kommt noch etwas".
 *
 * Das Skript liest nur, welcher Punkt aktiv ist, und setzt daraus Klassen.
 * Wer den aktiven Punkt setzt, ist ihm gleichgültig – hier ist es Flickity.
 *
 * Ohne dieses Skript bleibt eine vollständige, bedienbare Punktreihe stehen:
 * Alle Fenster-Regeln im CSS hängen an [data-custom-gallery-dots], und das
 * setzt erst der Code hier.
 */
(function () {
  'use strict';

  var WINDOW = 4;
  var SELECTOR = '.thb-product-detail .product-images .flickity-page-dots';
  var OUT = 'custom-gallery-dots-out';
  var SMALL = 'custom-gallery-dots-small';

  function isCurrent(el) {
    // Flickity markiert den aktiven Punkt doppelt. Beides zu pruefen macht das
    // Skript unabhaengig von der Flickity-Version.
    if (el.classList.contains('is-selected')) return true;
    var aria = el.getAttribute('aria-current');
    return aria === 'step' || aria === 'true';
  }

  function update(bar) {
    var items = Array.prototype.filter.call(bar.children, function (el) {
      return !el.hidden;
    });

    var total = items.length;
    if (total === 0) return;

    var current = 0;
    items.forEach(function (el, index) {
      if (isCurrent(el)) current = index;
    });

    var visible = Math.min(WINDOW, total);
    var maxOffset = total - visible;
    var offset = Math.max(0, Math.min(current - 2, maxOffset));

    bar.setAttribute('data-custom-gallery-dots', '');

    items.forEach(function (el, index) {
      var inWindow = index >= offset && index < offset + visible;
      var shrinkStart = index === offset && offset > 0;
      var shrinkEnd = index === offset + visible - 1 && offset < maxOffset;

      el.classList.toggle(OUT, !inWindow);
      el.classList.toggle(SMALL, inWindow && (shrinkStart || shrinkEnd));
    });
  }

  function bind(bar) {
    if (bar.dataset.customGalleryDotsBound === 'true') return;
    bar.dataset.customGalleryDotsBound = 'true';

    // Auf einen Frame zusammenfassen: Beim Blaettern aendert sich aria-current
    // zweimal (alter Punkt ab, neuer Punkt an).
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        update(bar);
      });
    }

    // attributeFilter bewusst ohne 'class': update() setzt selbst Klassen und
    // wuerde den Beobachter sonst endlos neu ausloesen. Flickity setzt beim
    // Wechsel ohnehin aria-current, das genuegt als Signal.
    new MutationObserver(schedule).observe(bar, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-current', 'hidden']
    });

    update(bar);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), bind);
  }

  function init() {
    scan();

    // Flickity baut die Punktreihe nach einem Variantenwechsel komplett neu
    // auf. Dieser Beobachter greift die frische Leiste auf, sobald sie im DOM
    // landet, und stellt ausserdem die Klassen wieder her, die Flickity beim
    // Setzen von className auf dem aktiven Punkt ueberschreibt.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        scan();
        Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), update);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
